import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { affiliates } from "../../../common/enums/affiliates";
import { GetAffiliate } from "../../../services/general.service";
import { cabin_luggage_icon_warning as CabinLuggageWarningIconTransavia } from "../../../assets/icons/transavia/index";
import { LocalStorageEnum } from "../../../common/enums/localStorageEnum";
import { ancillaryTypes } from "../../../common/constants/ancillaryTypes";
import { LocalStorageService } from "../../../services/local-storage.service";
import CrossIcon from "../../../assets/icons/klm/klm_cancel_extras_baggage.svg";
import CrossIconTransavia from "../../../assets/icons/transavia/transavia_cross_icon.svg";

const NoCabinBaggage = ({
  luggageData,
  onCabinBaggageSelectionChanged,
  setCabinSelectionState,
  cabinSelectionState,
  errorState,
  setErrorState,
  isError,
}) => {
  const NocabinBaggageData = luggageData[0]?.fields;

  const handleChange = () => {
    const requestData = {
      type: ancillaryTypes.CabinBaggage,
      travellerIdentifier: "",
      ancillaryOptionCode: "",
    };
    setErrorState({
      nothingSelected: false,
      noCabinPerPassengerSelected: false,
    });
    setCabinSelectionState({ cabinSelected: false, noCabinSelected: true });
    onCabinBaggageSelectionChanged(requestData);
  };

  const displayCabinLuggageWarningIcon = () => {
    return GetAffiliate() === affiliates.klm ? (
      <img alt="KLMWarningIcon" src={CabinLuggageWarningIconTransavia} />
    ) : (
      <img alt="TransaviaWarningIcon" src={CabinLuggageWarningIconTransavia} />
    );
  };

  const displayCrossIconCanelBaggage = () => {
    return GetAffiliate() === affiliates.klm ? (
      <img alt="KLMCrossIcon" src={CrossIcon} />
    ) : (
      <img alt="TransaviaCrossIcon" src={CrossIconTransavia} />
    );
  };

  return (
    <div
      className={`no-baggage-container ${
        cabinSelectionState.noCabinSelected ? "checked" : isError ? "error" : ""
      }`}
      onClick={handleChange}
    >
      <div className="no-baggage-card-info">
        <div className="no-baggage-radio-button">
          <input
            type="radio"
            checked={cabinSelectionState.noCabinSelected}
            onChange={handleChange}
            name="no-baggage-radio"
            aria-label="No Cabin Baggage"
            className={`radio-button-no-cabin ${isError ? "error" : ""}`}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
        <div className="no-baggage-text-box">
          <p className="no-baggage-title">
            {luggageData && luggageData[0]?.fields?.noCabinHeader}
          </p>
          <p className="no-baggage-subtitle">
            {luggageData && luggageData[0]?.fields?.noCabinDescription}
          </p>
        </div>
        <div className="remove-icon-box">{displayCrossIconCanelBaggage()}</div>
      </div>
      {cabinSelectionState?.noCabinSelected && (
        <div className="no-baggage-card-warning">
          <div className="no-baggage-card-warning-icon">
            {displayCabinLuggageWarningIcon()}
          </div>
          <div className="no-baggage-card-warning-info">
            {NocabinBaggageData && NocabinBaggageData?.noCabinWarningMessage}
          </div>
        </div>
      )}
    </div>
  );
};

export default NoCabinBaggage;
